// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"806":"user","884":"admin","993":"leerstand"}[chunkId] || chunkId) + "-legacy." + {"290":"bda32e2d","806":"4a8ee5a2","884":"6161e038","892":"5eabdfc1","993":"10edc12b"}[chunkId] + ".js";
};